import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Avatar,
  Box,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";



const InstallationGuide = (props: {
  guideOpenState: boolean;
  // setVersionOpenState: boolean;
  setGuideOpenState: (_0: boolean) => void;
  // versionLists: any[];
  URL: string
  // downloadHandler: (version: string) => void;
}) => {
  const { guideOpenState, setGuideOpenState, URL } = props;
  const [submitState, setSubmitState] = React.useState(false);
  console.log(URL)
  // console.log("versionLists", versionLists);

  const onSubmit = (data: any) => {
    setGuideOpenState(false);

    // setTimeout(() => {
    //   setFormOpenState(false);
    //   setSubmitState(false)
    // }, 4000);
  };

  const handleClose = () => {
    setGuideOpenState(false);
  };

  return (
    <div>
      <Dialog open={guideOpenState} onClose={handleClose}>
        <DialogTitle>Installation guide</DialogTitle>
        <DialogContent sx={{ width: "600px" }}>
          <Grid sx={{ width: "100%", textAlign: "center" }}>
                  <Box sx={{ position: "relative", paddingTop: "66.25%" }}>
                    <iframe
                      src={URL}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                    ></iframe>
                  </Box>
          </Grid>
         
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default InstallationGuide;
